import { PERMISSION_TYPE, type PERMISSION_VALUE } from '@/permissions'
import { ROLE_TYPE } from '../permissions'

export enum BLOCK_PERMISSION {
  ARROWS = 'ARROWS',
  DUPLICATE = 'DUPLICATE',
  MAKE_SYMBOL = 'MAKE_SYMBOL',
  NOTE = 'NOTE',
  RESOLVE = 'RESOLVE',
  IMAGE = 'IMAGE',
}

export const getBlockPermissionsMatrix = (): Record<
  BLOCK_PERMISSION,
  Record<ROLE_TYPE, PERMISSION_VALUE>
> => {
  return {
    [BLOCK_PERMISSION.ARROWS]: {
      [ROLE_TYPE.TRIAL_ANONYMOUS]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TRIAL_LOGGED]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.FREE_ANONYMOUS]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.FREE_LOGGED]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.FREE_PROJECT_MEMBER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.FREE_OWNER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.PRO_ANONYMOUS]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.PRO_LOGGED]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.PRO_PROJECT_MEMBER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.PRO_OWNER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_ANONYMOUS]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_LOGGED]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_PROJECT_MEMBER]: {
        type: PERMISSION_TYPE.YES,
      },
      [ROLE_TYPE.TEAM_AGENCY_MEMBER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_OWNER]: { type: PERMISSION_TYPE.YES },
    },
    [BLOCK_PERMISSION.DUPLICATE]: {
      [ROLE_TYPE.TRIAL_ANONYMOUS]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TRIAL_LOGGED]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.FREE_ANONYMOUS]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.FREE_LOGGED]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.FREE_PROJECT_MEMBER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.FREE_OWNER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.PRO_ANONYMOUS]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.PRO_LOGGED]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.PRO_PROJECT_MEMBER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.PRO_OWNER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_ANONYMOUS]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_LOGGED]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_PROJECT_MEMBER]: {
        type: PERMISSION_TYPE.YES,
      },
      [ROLE_TYPE.TEAM_AGENCY_MEMBER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_OWNER]: { type: PERMISSION_TYPE.YES },
    },
    [BLOCK_PERMISSION.MAKE_SYMBOL]: {
      [ROLE_TYPE.TRIAL_ANONYMOUS]: { type: PERMISSION_TYPE.NA },
      [ROLE_TYPE.TRIAL_LOGGED]: { type: PERMISSION_TYPE.NA },
      [ROLE_TYPE.FREE_ANONYMOUS]: { type: PERMISSION_TYPE.NA },
      [ROLE_TYPE.FREE_LOGGED]: { type: PERMISSION_TYPE.NA },
      [ROLE_TYPE.FREE_PROJECT_MEMBER]: { type: PERMISSION_TYPE.NA },
      [ROLE_TYPE.FREE_OWNER]: { type: PERMISSION_TYPE.NA },
      [ROLE_TYPE.PRO_ANONYMOUS]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.PRO_LOGGED]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.PRO_PROJECT_MEMBER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.PRO_OWNER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_ANONYMOUS]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_LOGGED]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_PROJECT_MEMBER]: {
        type: PERMISSION_TYPE.YES,
      },
      [ROLE_TYPE.TEAM_AGENCY_MEMBER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_OWNER]: { type: PERMISSION_TYPE.YES },
    },
    [BLOCK_PERMISSION.RESOLVE]: {
      [ROLE_TYPE.TRIAL_ANONYMOUS]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.TRIAL_LOGGED]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.FREE_ANONYMOUS]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.FREE_LOGGED]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.FREE_PROJECT_MEMBER]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.FREE_OWNER]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.PRO_ANONYMOUS]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.PRO_LOGGED]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.PRO_PROJECT_MEMBER]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.PRO_OWNER]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.TEAM_AGENCY_ANONYMOUS]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_LOGGED]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_PROJECT_MEMBER]: {
        type: PERMISSION_TYPE.YES,
      },
      [ROLE_TYPE.TEAM_AGENCY_MEMBER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_OWNER]: { type: PERMISSION_TYPE.YES },
    },
    [BLOCK_PERMISSION.NOTE]: {
      [ROLE_TYPE.TRIAL_ANONYMOUS]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TRIAL_LOGGED]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.FREE_ANONYMOUS]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.FREE_LOGGED]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.FREE_PROJECT_MEMBER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.FREE_OWNER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.PRO_ANONYMOUS]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.PRO_LOGGED]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.PRO_PROJECT_MEMBER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.PRO_OWNER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_ANONYMOUS]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_LOGGED]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_PROJECT_MEMBER]: {
        type: PERMISSION_TYPE.YES,
      },
      [ROLE_TYPE.TEAM_AGENCY_MEMBER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_OWNER]: { type: PERMISSION_TYPE.YES },
    },
    [BLOCK_PERMISSION.IMAGE]: {
      [ROLE_TYPE.TRIAL_ANONYMOUS]: {
        type: PERMISSION_TYPE.NA_BADGE,
        badge: 'plan_pro',
      },
      [ROLE_TYPE.TRIAL_LOGGED]: {
        type: PERMISSION_TYPE.NA_BADGE,
        badge: 'plan_pro',
      },
      [ROLE_TYPE.FREE_ANONYMOUS]: {
        type: PERMISSION_TYPE.NA_BADGE,
        badge: 'plan_pro',
      },
      [ROLE_TYPE.FREE_LOGGED]: {
        type: PERMISSION_TYPE.NA_BADGE,
        badge: 'plan_pro',
      },
      [ROLE_TYPE.FREE_PROJECT_MEMBER]: {
        type: PERMISSION_TYPE.NA_BADGE,
        badge: 'plan_pro',
      },
      [ROLE_TYPE.FREE_OWNER]: {
        type: PERMISSION_TYPE.NA_BADGE,
        badge: 'plan_pro',
      },
      [ROLE_TYPE.PRO_ANONYMOUS]: { type: PERMISSION_TYPE.NA },
      [ROLE_TYPE.PRO_LOGGED]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.PRO_PROJECT_MEMBER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.PRO_OWNER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_ANONYMOUS]: { type: PERMISSION_TYPE.NA },
      [ROLE_TYPE.TEAM_AGENCY_LOGGED]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_PROJECT_MEMBER]: {
        type: PERMISSION_TYPE.YES,
      },
      [ROLE_TYPE.TEAM_AGENCY_MEMBER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_OWNER]: { type: PERMISSION_TYPE.YES },
    },
  }
}
